var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useMemo, } from 'react';
import { Picker, } from '../Picker';
import { defaultProps as pickerDefaultProps } from '../Picker/Picker';
import { ShortTextPickerContext } from './ShortTextPickerContext';
const defaultProps = Object.assign(Object.assign({}, pickerDefaultProps), { size: 'medium' });
const ShortTextPicker = (_a) => {
    var { children, size = defaultProps.size } = _a, pickerProps = __rest(_a, ["children", "size"]);
    const providerValue = useMemo(() => ({
        size,
    }), [
        size,
    ]);
    return (_jsx(Picker, Object.assign({}, pickerProps, { modifier: "default" }, { children: _jsx(ShortTextPickerContext.Provider, Object.assign({ value: providerValue }, { children: children })) })));
};
const MemoizedShortTextPicker = memo(ShortTextPicker);
export { MemoizedShortTextPicker as ShortTextPicker };
// MC-1068 Temporary hack for Storybook.
export default ShortTextPicker;
